module.exports = __webpack_public_path__ + "static/img/clearCacheBg.1761547470324.png";